import { render } from "./zhudansousuo.vue?vue&type=template&id=272a9082&scoped=true"
import script from "./zhudansousuo.vue?vue&type=script&lang=js"
export * from "./zhudansousuo.vue?vue&type=script&lang=js"

import "./zhudansousuo.vue?vue&type=style&index=0&id=272a9082&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272a9082"]])

export default __exports__